(ns kyber.kyber-db.content-provider)

(def model
  {:ident-key
   :content-provider/uuid

   :refs
   {:content-provider/tag-groups {:model :content-provider.tag-group
                                  :cardinality :many}
    :content-provider/curricula {:model :curriculum
                                 :cardinality :many}}

   :schema
   #:content-provider
   {:uuid
    {:doc "UUID of a content provider"}

    :tag-groups
    {:doc "Tag groups assigned to a content provider"}

    :curricula
    {:doc "Curricula created by a content provider"}}})
